import {isParentWindow} from '@/api/consts';
import {Logger} from '@vanti/vue-logger';
import vueTime, {onTheMinute} from '@vanti/vue-time';
import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth';
import autoCheckOut from './auto-check-out';
import bookings from './bookings';
import config from './config';
import loading from './loading';
import resources from './resources';
import serviceWorker from './service-worker';
import offline from './offline';

import panelLights from './plugins/panel-lights';
import update from './plugins/update';
import room from './room';
import versions from './versions';
import hybridOffice from '@/hybrid-office/store';

const log = Logger.get('store');

Vue.use(Vuex);

let store;

// this is to avoid reload during acquireTokenSilent() because of hidden iframe used for auth
//
// if this happens the store plugins will be initialised and will cause errors (including setting
// the panel LEDs to an incorrect state)
//
// eslint-disable-next-line max-len
// see: https://github.com/AzureAD/azure-activedirectory-library-for-js/wiki/FAQs#q1-my-app-is-re-loading-every-time-adal-renews-a-token
if (isParentWindow) {
  log.debug('initialising');

  store = new Vuex.Store({
    modules: {
      auth,
      autoCheckOut,
      bookings,
      hybridOffice,
      resources,
      config,
      loading,
      serviceWorker,
      room,
      versions,
      offline
    },
    getters: {
      createableSnippet(state) {
        const userRef = state.config.userConfigRef;
        if (!userRef) {
          return {};
        }
        return {
          createdVia: {
            ref: userRef.firestore.doc('tools/booking-panel'),
            title: 'Booking Panel'
          }
        };
      }
    },
    actions: {
      init() {
      }
    },
    plugins: [
      panelLights,
      update,
      vueTime({interval: onTheMinute})
    ]
  });

  store.dispatch('init')
      .catch(err => log.error('in store init', err));
} else {
  log.debug('in iframe, skipping initialisation');
  store = new Vuex.Store({});
}

export default store;
